export default {
  products: [],
  energieGroups: {
    1: "electricity",
    2: "gas",
    3: "water",
    4: "internet",
    5: "credit",
    6: "electricityandgas",
    7: "cityheat",
    8: "mobile",
    9: "bankaccount",
    10: "insurance",
    11: "cleaning",
    58: "hypotheek"
  }
};
